import {
  Card,
  HStack,
  Image,
  Spacer,
  useBreakpointValue,
  VStack,
} from "@chakra-ui/react";

import { BodyText } from "../body-text";
import { ConnectWalletButton } from "../connect-wallet-button";
import { HeaderText } from "../header-text";

export const ConnectWalletBanner = ({ bodyText }: { bodyText: string }) => {
  const showFullWidthBanner = useBreakpointValue({
    base: false,
    sm: false,
    md: true,
  });
  if (showFullWidthBanner)
    return (
      <Card.Root w="full" rounded="2xl" borderColor="bg.muted">
        <Card.Body>
          <HStack gap={6}>
            <Image src="/assets/banner/wallets-icon.svg" boxSize={14} />
            <VStack alignItems="start">
              <HeaderText>Connect Your Wallet to Get Started</HeaderText>
              <BodyText>{bodyText}</BodyText>
            </VStack>
            <Spacer />
            <ConnectWalletButton />
          </HStack>
        </Card.Body>
      </Card.Root>
    );

  return (
    <Card.Root rounded="2xl" borderColor="bg.muted">
      <Card.Body>
        <HStack mb={6}>
          <Image src="/assets/banner/wallets-icon.svg" boxSize={14} />
          <Spacer />
          <ConnectWalletButton />
        </HStack>
        <VStack alignItems="start">
          <HeaderText>Connect Your Wallet to Get Started</HeaderText>
          <BodyText>{bodyText}</BodyText>
        </VStack>
      </Card.Body>
    </Card.Root>
  );
};
